<section class="area-login animate__animated animate__fadeIn">

  <!-- Spinner y logo -->
  <mat-card class="login" style="position: relative;" *ngIf="showSpinner">
    <mat-card-content>
      <div class="simpli-floating-box-header">
        <div class="simpli-floating-box-logo text-center">
          <img src="../../assets/simpli/simpli.svg" height="90px">
        </div>
        <div class="simpli-floating-box-title ">
          <span class="color-tertiary">
            Ingresa y haz todo más <span class="simpli-color1"> Simpli </span>
          </span>
        </div>
        <div class="text-center col-top">
          <i class="fa-solid fa-spinner fa-spin-pulse" style="color: var(--simpli-secondary); font-size: 36px;"></i>
        </div>
      </div>
    </mat-card-content>
  </mat-card>

  <!-- Formulario -->
  <mat-card class="login" style="position: relative;" *ngIf="!showSpinner && showForm">
    <mat-card-content>

      <div class="simpli-floating-box-header">
        <div class="simpli-floating-box-logo text-center">
          <img src="../../assets/simpli/simpli.svg" height="90px">
        </div>

        <div class="simpli-floating-box-title text-center">
          <span class="color-tertiary">
            Completa tu registro con una clave segura
          </span>
        </div>
      </div>

      <div>
        <form [formGroup]="valForm" (submit)="submitForm($event, valForm.value)"
          class="form-login animate__animated animate__fadeIn">

          <mat-form-field appearance="fill" color="primary">
            <mat-label>Contraseña</mat-label>
            <input formControlName="password" matInput type="password" [type]="hidePassword ? 'password' : 'text'"
              required>
            <button matSuffix mat-icon-button type="button" (click)="hidePassword = !hidePassword"
              [attr.aria-label]="'Ocultar password'" [attr.aria-pressed]="hidePassword">
              <mat-icon class="simpli-color-gris">{{hidePassword ? 'visibility_off' : 'visibility'}}</mat-icon>
            </button>
            <mat-hint>Ingresa tu contraseña</mat-hint>
            <mat-error *ngIf="valForm.controls['password'].hasError('required')">
              Este campo es <strong>obligatorio</strong>
            </mat-error>
            <mat-error *ngIf="valForm.controls['password'].hasError('minlength')">
              Debe contener un mínimo de 6 caracteres
            </mat-error>
          </mat-form-field>

          <mat-form-field appearance="fill" color="primary" style="margin-top: 20px;">
            <mat-label>Repite contraseña</mat-label>
            <input formControlName="confirmPassword" matInput type="password"
              [type]="hideConfirmPassword ? 'password' : 'text'" required>
            <button matSuffix mat-icon-button type="button" (click)="hideConfirmPassword = !hideConfirmPassword"
              [attr.aria-label]="'Ocultar password'" [attr.aria-pressed]="hideConfirmPassword">
              <mat-icon class="simpli-color-gris">{{hideConfirmPassword ? 'visibility_off' : 'visibility'}}</mat-icon>
            </button>
            <mat-hint>Repita la contraseña</mat-hint>
            <mat-error *ngIf="valForm.controls['confirmPassword'].hasError('required')">
              Este campo es <strong>obligatorio</strong>
            </mat-error>
            <mat-error
              *ngIf="valForm.controls['confirmPassword'].hasError('equalTo') && !valForm.controls['confirmPassword'].hasError('required')">
              Las contraseñas no coinciden
            </mat-error>
          </mat-form-field>



          <div class="btn-container">
            <button class="primary-button" [disabled]="showSpinner" mat-flat-button type="submit" color="primary">
              <mat-label *ngIf="!showSpinner">Ingresar</mat-label>
              <span *ngIf="showSpinner">
                <i class="fa-solid fa-spinner fa-spin-pulse" style="color:var(--simpli-secondary);font-size: 18px;"></i>
              </span>
            </button>
          </div>

        </form>
      </div>

    </mat-card-content>
  </mat-card>

  <!-- Mensaje de error -->
  <mat-card class="login" style="position: relative;" *ngIf="!showSpinner && !showForm">
    <mat-card-content>

      <div class="simpli-floating-box-body">
        <div class="simpli-floating-box-logo text-center" style="text-align: center;">
          <img src="assets/img/warning.png" alt="">
        </div>
        <div class="text-center">
          <span>
            <strong>¡Ups! Algo ocurrió en el proceso</strong>
          </span>
          <span>El enlace ha caducado. Solicita nuevamente acceso y te enviaremos un nuevo correo con un enlace actualizado</span>
        </div>

        <div class="btn-container">
          <button class="primary-button" (click)="reapply()" mat-flat-button type="submit" color="primary">
            <span *ngIf="!spinner">Volver a solicitar</span>
            <span *ngIf="spinner"><i class="fa-solid fa-spinner fa-spin-pulse"></i></span>
          </button>
        </div>
        
      </div>

    </mat-card-content>
  </mat-card>
</section>